import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, withDirectives as _withDirectives, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.comp)
    ? _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent($setup.props.comp.is), _normalizeProps(_mergeProps({ key: 0 }, $setup.props.comp.props)), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($setup.props.comp.content ? $setup.props.comp.content : "") + " ", 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.comp.children, (child, ind) => {
            return (_openBlock(), _createBlock($setup["ModalView"], { comp: child }, null, 8 /* PROPS */, ["comp"]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)), [
        [$setup["vDynamicEvents"], $setup.props.comp.events || []]
      ])
    : _createCommentVNode("v-if", true)
}